import products from "./products/phase1_products";
import vendorOrders from "./products/phase1_vendorOrders";

export default {
  modules: {
    products,
    vendorOrders,
  },
};
